import { Link } from "react-router-dom";
import { ArrowRight, Landmark, FileSpreadsheet, Users, CalendarClock, GitCompareArrows,
  LifeBuoy, CalendarCheck, FolderLock, Radar, PackageCheck } from "lucide-react";

const SERVICES = [
  { icon: Landmark, title: "Arizona TPT Management", text: "Full Transaction Privilege Tax lifecycle: rate rules by jurisdiction, monthly periods, return preparation, review, filing coordination, and payment tracking with confirmations." },
  { icon: FileSpreadsheet, title: "Federal Business Tax Coordination", text: "Track federal estimated tax obligations alongside state filings so nothing competes for the same dollars." },
  { icon: Users, title: "Payroll Tax Coordination", text: "Coordinate 941 deposits and state withholding accounts with reserves reflected in your Safe-to-Spend number." },
  { icon: CalendarClock, title: "Estimated Tax Planning", text: "Quarterly estimate planning based on your real imported sales, not guesses." },
  { icon: GitCompareArrows, title: "Merchant Sales Reconciliation", text: "We compare merchant processor totals, bank deposits, and reported sales — and flag every discrepancy." },
  { icon: LifeBuoy, title: "Past-Due Tax Reconstruction", text: "AZ Tax Rescue rebuilds missing periods from bank and merchant records, estimates exposure, and brings you current." },
  { icon: CalendarCheck, title: "Tax Payment Scheduling", text: "Schedule payments with authorization records. A payment is only 'paid' when the authority confirms it." },
  { icon: FolderLock, title: "Business Tax Document Management", text: "A secure vault for returns, notices, statements, and confirmations — organized, searchable, audit-ready." },
  { icon: Radar, title: "Tax Compliance Monitoring", text: "Your compliance score, upcoming deadlines, shortfalls, and missing documents monitored continuously." },
  { icon: PackageCheck, title: "Year-End Tax Package Preparation", text: "One click compiles your annual revenue, filings, payments, and confirmations into a downloadable package." },
];

export default function Services() {
  return (
    <div>
      <section className="border-b border-slate-200 bg-white py-14">
        <div className="mx-auto max-w-7xl px-4 sm:px-6">
          <div className="text-xs font-semibold uppercase tracking-widest text-copper">Services</div>
          <h1 className="mt-2 text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">Business Tax, Managed End-to-End</h1>
          <p className="mt-4 max-w-2xl text-slate-600">From the first imported sale to the final payment confirmation, AZ Tax Accounts runs the compliance pipeline with you in control of every authorization.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 py-14 sm:px-6">
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s) => (
            <div key={s.title} className="card-gov p-6 transition-transform hover:-translate-y-0.5" data-testid={`service-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
              <div className="flex h-11 w-11 items-center justify-center rounded-md bg-navy text-white"><s.icon className="h-5 w-5" /></div>
              <h3 className="mt-4 text-lg font-bold text-navy">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.text}</p>
            </div>
          ))}
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 rounded-md border border-gold/50 bg-gold-50 p-6">
          <div>
            <div className="font-bold text-navy">Not sure where to start?</div>
            <div className="text-sm text-slate-600">Talk to a tax specialist about your situation — no obligation.</div>
          </div>
          <Link to="/consultation" className="btn-copper" data-testid="services-consultation-cta">Book a Consultation <ArrowRight className="h-4 w-4" /></Link>
        </div>
      </section>
    </div>
  );
}
